import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment'
import { SharedService } from '@shared/shared.service';
@Injectable()
export class FileUploadService {


  domainName: string = this._SharedService.domainName;

  // API url
  fileUploadurl = environment.fileUploadurl ?? 'https://nexgen.sprintnxt.in/api/upload-normal-file';
  // baseApiUrl = 'https://kyc.vsts.net.in/server/public/index.php/api/uploadVideo_kyc';
  private httpClient: HttpClient;
  constructor(private _HttpBackend: HttpBackend, private _SharedService: SharedService) {
    this.httpClient = new HttpClient(_HttpBackend);
  }


  // Returns an observable
  upload(formData: FormData): Observable<any> {

    formData.append('domain_url', this.domainName);


    // Make http post request over api
    // with formData as req
    return this.httpClient.post(this.fileUploadurl, formData);
  }

  videoupload(file: any): Observable<any> {

    // Create form data
    const formData = new FormData();

    // Store form name as "file" with file data
    formData.append("file", file, file.type);

    // Make http post request over api
    // with formData as req
    return this.httpClient.post(this.fileUploadurl, formData)
  }
}
